import { useCallback } from "react";
import { useUserState } from "@/hooks/userState/useUserState";

const DEFAULTS = { enabled: false };

/**
 * Whether the fleet check also reads Geotab's GPS odometer, remembered per user.
 *
 * Off by default: Geotab hands it out only per vehicle, so it costs one call per vehicle on top
 * of the scan's few per diagnostic.
 */
export function useGpsOdometerSetting() {
  const { value, setValue } = useUserState("vehicleDataCheck:gpsOdometer", DEFAULTS);

  const setEnabled = useCallback((enabled: boolean) => setValue({ enabled }), [setValue]);

  return { enabled: value.enabled === true, setEnabled };
}
